import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_NAME } from '@/utils/constants';

export default function ConfirmationSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home page after 5 seconds
    const timeout = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Subscription Confirmed!
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Thank you for confirming your subscription to {APP_NAME}. Your account is now active.
          </p>
        </div>
        <div className="mt-4">
          <p className="text-sm text-gray-500">
            You will be redirected to the homepage in a few seconds...
          </p>
          <button
            onClick={() => navigate('/')}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
          >
            Return to Homepage
          </button>
        </div>
      </div>
    </div>
  );
}